/**
 * Stable identifier for this browser installation.
 *
 * Generated once and kept in localStorage so appearance and similar per-device
 * settings can be stored on the server under one row per user and device.
 */

const STORAGE_KEY = 'relaii.client_device_id'

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

export function getClientDeviceId(): string {
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY)
    if (existing !== null && existing.length >= 8) return existing

    const created = randomId()
    window.localStorage.setItem(STORAGE_KEY, created)
    return created
  } catch {
    return randomId()
  }
}
